import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// primeReact
import { Button } from "primereact/button";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Accordion, AccordionTab } from "primereact/accordion";
// components
import ClientInfo from "./ClientInfo";
import AccordionSale from "../AccordionSale";
import ReactInputMask from "react-input-mask";
import SimulationInvoice from "../../SimulationInvoice";
// context
import { useContextSimulator } from "../../SimulatorContext";
import { useAppContext } from "../../../../../../context/AppContext";
//services
import { postSale } from "../../../../../../services/Simulator/postSale";
import { postPublicSale } from "../../../../../../services/Public/postPublicSale";

const ModalSimulator = ({ empId, name, hash, publicProps = null }) => {
  const navigate = useNavigate();
  const { permissions } = useAppContext();
  const {
    team,
    member,
    members,
    setMemberData,
    simulatorData,
    setClientId,
    handleTeam,
    handleSimulation,
    stage,
    setStage,
    simulationData,
    simulationDataLoading,
    simulationId,
    setConfigVisible,
    setShowModalClient,
    setTestId,
    setSkeleton,
    imobiliarias,
    corretores,
    selectedImob,
    setSelectedImob,
    selectedCorr,
    setSelectedCorr,
    loadingTeams,
    publicClientData,
    setPublicClientData,
    crmData,
  } = useContextSimulator();

  const [loadingProposal, setLoadingProposal] = useState(false);
  const [mask, setMask] = useState("99.999.999/9999-99");

  const handleMemberData = (memberId) => {
    const filter = members.filter((member) => member.id === memberId);
    setMemberData(filter[0]);
  };

  const handleProposal = async () => {
    let notification = toast.loading("Enviando proposta...");
    setLoadingProposal(true);

    let response;
    if (empId === 0) {
      if (publicProps.role === "Corretor") {
        response = await postSale({ simulation_id: simulationId });
      } else {
        response = await postPublicSale(simulationId);
      }
    } else {
      response = await postSale({ simulation_id: simulationId });
    }

    toast.update(notification, {
      render: `${response.success}`,
      type: "success",
      theme: "colored",
      autoClose: 5000,
      isLoading: false,
    });
    setTestId(null);
    setLoadingProposal(false);
    setShowModalClient(false);
    // setConfigVisible(true);

    if (empId === 0) {
      navigate(`/publicMap/${hash}`);
    } else if (crmData) {
      console.log({crmData});
      crmData.setHasReserved(true);
    } else {
      navigate(`/enterprise/${empId}`, { state: { name: name } });
    }

    // setMemberData(null);

    setSkeleton(true);
    // setFirstEntryParcelDate(null)
    //    console.log(response);
  };

  const watchMask = (value) => {
    if (value.length <= 14) {
      setMask("999.999.999-999");
      setPublicClientData((prevState) => ({
        ...prevState,
        doc: value,
        type_doc: 1
      }))
    } else {
      setMask("99.999.999/9999-99");
      setPublicClientData((prevState) => ({
        ...prevState,
        doc: value,
        type_doc: 2
      }))
    }
  };

  // console.log(publicProps)
  // console.log(publicProps.userId)
  // console.log(publicProps.role)
  // console.log(publicProps.decodedData)
  // console.log(publicProps.userId === 'undefined' || (publicProps.role === "Cliente" && !publicProps.decodedData))
// console.log("EmpID ModalSimulator", empId);
  return (
    <>
      {stage === 0 && (
        empId === 0 ? (
          <>
            {/* Se não houver userId, renderiza os campos de cliente */}
            {(!publicProps.userId || publicProps.userId === 'undefined' || (publicProps.role === "Cliente" && !publicProps.decodedData)) && (
              <div className="row pt-2">
                <div className="col-md-6 py-3">
                  <span className="p-float-label">
                    <ReactInputMask
                      mask={mask}
                      maskChar={null}
                      value={publicClientData?.doc || ""}
                      required
                      onChange={(event) => watchMask(event.target.value)}
                      placeholder="CPF / CNPJ *"
                      className={`w-100 p-inputtext p-component p-inputmask ${publicClientData?.doc ? "p-filled" : ""}`}
                    />
                    <label>Documento</label>
                  </span>
                </div>
                <div className="col-md-6 py-3">
                  <span className="p-float-label">
                    <InputText
                      value={publicClientData?.name || ""}
                      onChange={(e) =>
                        setPublicClientData((prevState) => ({
                          ...prevState,
                          name: e.target.value,
                        }))
                      }
                      placeholder="Nome Completo"
                      className="w-100"
                    />
                    <label>Nome Completo</label>
                  </span>
                </div>
                <div className="col-md-6 py-3">
                  <span className="p-float-label">
                    <InputMask
                      value={publicClientData?.phone || ""}
                      onChange={(e) =>
                        setPublicClientData((prevState) => ({
                          ...prevState,
                          phone: e.target.value,
                        }))
                      }
                      placeholder="Telefone"
                      className="w-100"
                      mask="(99) 99999-999?9"
                    />
                    <label>Telefone</label>
                  </span>
                </div>
                <div className="col-md-6 py-3">
                  <span className="p-float-label">
                    <InputText
                      value={publicClientData?.email || ""}
                      onChange={(e) =>
                        setPublicClientData((prevState) => ({
                          ...prevState,
                          email: e.target.value,
                        }))
                      }
                      placeholder="Email"
                      className="w-100"
                    />
                    <label>Email</label>
                  </span>
                </div>
              </div>
            )}

            {/* Se o usuário for um Corretor, renderiza a seção de Vendedor e Comprador */}
            {publicProps.role === "Corretor" && (
              <Accordion activeIndex={!team && !member ? 0 : 1}>
                <AccordionTab
                  header={
                    <div className="flex align-items-center">
                      <i className="fa-solid fa-user-tie me-2"></i>
                      <span className="vertical-align-middle">Vendedor</span>
                    </div>
                  }
                >
                  <AccordionSale sellerId={publicProps.userId || null} />
                </AccordionTab>
                <AccordionTab
                  header={
                    <div className="flex align-items-center">
                      <i className="fa-solid fa-user me-2"></i>
                      <span className="vertical-align-middle">Comprador</span>
                    </div>
                  }
                >
                  <ClientInfo setClientId={setClientId} />
                </AccordionTab>
              </Accordion>
            )}

            {/* Se o usuário for um Cliente */}
            {(publicProps.decodedData && publicProps.role === "Cliente") && (
              <>
                <div className="row pt-2">
                  <div className="col-md-6 py-3">
                    <span className="p-float-label">
                      <InputText
                        // mask={mask}
                        // maskChar={null}
                        value={publicProps.decodedData.doc}
                        required
                        onChange={(event) => watchMask(event.target.value)}
                        placeholder="CPF / CNPJ *"
                        className={`w-100 p-inputtext p-component p-inputmask ${publicClientData?.doc ? "p-filled" : ""}`}
                        disabled
                      />
                      <label>Documento</label>
                    </span>
                  </div>
                  <div className="col-md-6 py-3">
                    <span className="p-float-label">
                      <InputText
                        value={publicProps.decodedData.name}
                        onChange={(e) =>
                          setPublicClientData((prevState) => ({
                            ...prevState,
                            name: e.target.value,
                          }))
                        }
                        placeholder="Nome Completo"
                        className="w-100"
                        disabled
                      />
                      <label>Nome Completo</label>
                    </span>
                  </div>
                  <div className="col-md-6 py-3">
                    <span className="p-float-label">
                      <InputMask
                        value={publicProps.decodedData.phone}
                        onChange={(e) =>
                          setPublicClientData((prevState) => ({
                            ...prevState,
                            phone: e.target.value,
                          }))
                        }
                        placeholder="Telefone"
                        className="w-100"
                        mask="(99) 99999-999?9"
                        disabled
                      />
                      <label>Telefone</label>
                    </span>
                  </div>
                  <div className="col-md-6 py-3">
                    <span className="p-float-label">
                      <InputText
                        value={publicProps.decodedData.email}
                        onChange={(e) =>
                          setPublicClientData((prevState) => ({
                            ...prevState,
                            email: e.target.value,
                          }))
                        }
                        placeholder="Email"
                        className="w-100"
                        disabled
                      />
                      <label>Email</label>
                    </span>
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <Accordion activeIndex={!team && !member ? 0 : 1}>
            <AccordionTab
              header={
                <div className="flex align-items-center">
                  <i className="fa-solid fa-user-tie me-2"></i>
                  <span className="vertical-align-middle">Vendedor</span>
                </div>
              }
            >
              <AccordionSale sellerId={publicProps.role === "Corretor" ? publicProps.userId : crmData?.broker_id || null} />
            </AccordionTab>
            <AccordionTab
              header={
                <div className="flex align-items-center">
                  <i className="fa-solid fa-user me-2"></i>
                  <span className="vertical-align-middle">Comprador</span>
                </div>
              }
            >
              {/* {console.log(crmData)} */}
              <ClientInfo clientId={crmData?.user_id || null} setClientId={setClientId} />
            </AccordionTab>
          </Accordion>
        )
      )}
      {stage === 1 && (
        <>
          <SimulationInvoice />
        </>
      )}

      <div className="row text-end justify-content-between pt-4">
        {stage === 1 ? (
          <>
            <div className="col-md-4 text-start">
              <Button
                label="Voltar"
                icon="fa-solid fa-chevron-left"
                severity="secondary"
                iconPos="left"
                onClick={() => setStage(0)}
              />
            </div>
            {(permissions.includes("31") || publicProps.isPublic) && (
              <div className="col-md-4">
                <Button
                  label="Enviar Proposta"
                  icon="fa-solid fa-chevron-right"
                  iconPos="right"
                  loading={loadingProposal}
                  onClick={() => handleProposal()}
                />
              </div>
            )}
          </>
        ) : (
          <div className="col-md-12 text-end">
            <Button
              label="Visualizar Simulação"
              icon="fa-solid fa-chevron-right"
              iconPos="right"
              onClick={() => handleSimulation()}
              loading={simulationDataLoading}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ModalSimulator;
